'use client';

import styles from './caPrivacy.module.css';
import Footer from '@components/footer/Footer';
import Navbar from '@components/Navbar';

export default function CAPrivacyPage() {
  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <header className={styles.heroSection}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>California Supplemental Notice</h1>
            <p className={styles.updatedDate}>Last updated December 17, 2025</p>
          </div>
        </header>

        <main className={styles.privacyContent}>
          <section>
            <p className={styles.contentText}>
              Our Privacy Notice explains how we,{' '}
              <strong>PenguinLearn Holdings LLC, doing business as PenguinLearn</strong>, collect and use
              personal data when you use our website and services (collectively, the “Services”). This
              Supplemental California Privacy Notice (“CA Notice”) applies to California residents who
              use the Services. This CA Notice does not apply where an exception under the California
              Consumer Privacy Act (“CCPA”) applies.
            </p>
          </section>

          <section>
            <h2 className={styles.header}>
              Our Personal Data Handling Practices over the Preceding 12 Months
            </h2>
            <p>
              In the last 12 months, we collected the categories of personal data described in the section
              titled “Your Personal Data” of our Privacy Notice. These categories correspond to the
              categories of “personal information” defined under the CCPA.
            </p>

            <ul className={styles.list}>
              <li>
                <strong>Identifiers</strong> such as a real name, alias, email address, and account name.
              </li>
              <li>
                <strong>Information capable of being associated with you</strong>, including payment
                information related to purchases.
              </li>
              <li>
                <strong>Characteristics of protected classifications</strong> under California or federal
                law, including age, sex, gender identity, or disability, where voluntarily provided or
                required for lawful purposes.
              </li>
              <li>
                <strong>Commercial information</strong>, including records of services purchased, obtained,
                or considered.
              </li>
              <li>
                <strong>Audio, electronic, visual, or similar information</strong>, such as live class
                audio/video and class recordings.
              </li>
              <li>
                <strong>Professional or employment-related information</strong>, such as information
                provided by Teachers for onboarding and participation.
              </li>
              <li>
                <strong>Education information</strong>, including class participation and learning-related
                activity.
              </li>
              <li>
                <strong>Inferences</strong> drawn from the information above to improve platform operations
                and class experiences.
              </li>
            </ul>

            <p>
              We collected this personal data as described in our Privacy Notice and used it for the
              purposes described there, including providing and operating the Services, processing
              payments, enabling live classes, ensuring safety, preventing fraud, and maintaining platform
              functionality.
            </p>

            <p>
              In the last 12 months, we disclosed personal data to the categories of recipients described in
              the section titled “Sharing Your Data” of our Privacy Notice, such as Teachers, service
              providers, payment processors, video providers, and background check providers.
            </p>

          </section>

          <br />

          <section>
            <h2 className={styles.header}>California Rights and Choices</h2>
            <p>
              If you are a California resident, you have certain rights related to your personal data under
              the CCPA, subject to applicable exceptions.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Right to Know / Portability
            </h3>
            <p>
              You may request disclosure of certain information about the personal data we collected about
              you within the past twelve months. Once we verify your request, we will disclose:
            </p>
            <ul className={styles.list}>
              <li>The categories of personal data we collected about you;</li>
              <li>The categories of sources from which the personal data was collected;</li>
              <li>The business or commercial purpose for collecting personal data;</li>
              <li>The categories of third parties to whom personal data was disclosed; and</li>
              <li>The specific pieces of personal data collected about you.</li>
            </ul>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Right to Deletion
            </h3>
            <p>
              You may request deletion of your personal data, subject to certain exceptions. If your
              PenguinLearn account is deleted, you will no longer be able to access the Services and would
              need to create a new account.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Right to Non-Discrimination
            </h3>
            <p>
              We will not discriminate against you for exercising any rights under the CCPA.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              How to Submit a Request
            </h3>
            <p>
              Requests may be submitted by emailing{' '}
              <a className={styles.emailLink} href="mailto:support@penguinlearn.com">
                support@penguinlearn.com
              </a>.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Verifiable Requests
            </h3>
            <p>
              We take reasonable steps to verify your identity before responding to a request.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Authorized Agents
            </h3>
            <p>
              You may designate an authorized agent to make a request on your behalf. Parents or guardians
              may also make requests on behalf of their minor children.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Responding to Requests
            </h3>
            <p>
              We will confirm receipt of your request and respond within the timeframes required by law.
            </p>

            <br />

            <h3 className={styles.header} style={{ fontSize: '19px' }}>
              Other California Privacy Rights
            </h3>
            <p>
              California residents under the age of 18 may request removal of content they have publicly
              posted by contacting{' '}
              <a href="mailto:support@penguinlearn.com" className={styles.emailLink}>
                support@penguinlearn.com
              </a>.
            </p>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}